// Campus photo for /colleges/ohio-university: Public domain, by Ottawa80, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AManasseh_Cutler_Hall%2C_Ohio_University.jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/ohio-university/; credited under the photo.
const photo = {
    "slug": "ohio-university",
    "alt": "Cutler Hall and its white cupola behind the trees at Ohio University in Athens, Ohio",
    "src": "/colleges/ohio-university/campus-1600.webp",
    "srcSmall": "/colleges/ohio-university/campus-800.webp",
    "srcMid": "/colleges/ohio-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/ohio-university/og.jpg",
    "title": "Manasseh Cutler Hall, Ohio University",
    "author": "Ottawa80",
    "license": "Public domain",
    "licenseUrl": null,
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AManasseh_Cutler_Hall%2C_Ohio_University.jpg",
    "read": "2026-10-02"
};

export default photo;
